module.exports = __webpack_public_path__ + "img/27_33.682c2749.png";